var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { OrderedOption } from '../../OrderedOption/OrderedOption';
export class OrderedTaskEdit {
    parent;
    //@editable() editCorrectIndexOrder: string;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get task() {
        return this.parent;
    }
    get canRemoveOption() {
        return this.task.options.length > 2;
    }
    addOption() {
        const newOption = OrderedOption.fromSerialized({ parent: this.task });
        this.task.options.push(newOption);
    }
    removeOption() {
        this.task.options.pop();
    }
}
__decorate([
    action.bound
], OrderedTaskEdit.prototype, "addOption", null);
__decorate([
    action.bound
], OrderedTaskEdit.prototype, "removeOption", null);
